import React, { ReactNode } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import MLongMenu from "./MLongMenu"; // Importa el menú desplegable genérico

const ActionMenu = ({ actions }: { actions: ReactNode[] }) => {
  const isMobileOrTablet = useMediaQuery("(max-width: 768px)");

  return (
    <div>
      {isMobileOrTablet ? (
        <MLongMenu actions={actions} />
      ) : (
        <div>
          {actions.map((action, index) => (
            <span key={index}>{action}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActionMenu;
